import React, { memo } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

const Wrapper = styled.div`
    position: relative;

    circle {
        transition: stroke-dashoffset 0.1s linear, stroke 0.2s ease-in-out;
        stroke-linecap: round;
        fill: none;
    }

    div.content {
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
    }
`

const ProgressWheel = (props) => {
    const strokeWidthCapped = Math.min(props.strokeWidth, props.size / 2 - 1)
    const radius = Math.max((props.size - strokeWidthCapped) / 2 - 1, 0)
    const circumference = 2 * Math.PI * radius
    const circleProps = {
        cx: props.size / 2,
        cy: props.size / 2,
        r: radius,
        strokeWidth: strokeWidthCapped,
        strokeDasharray: circumference,
        transform: 'rotate(' + -90 + ',' + props.size / 2 + ',' + props.size / 2 + ')'
    }

    return (
        <Wrapper>
            <div
                className="content"
                style={{
                    width: props.size - props.strokeWidth * 2 + 'px',
                    height: props.size - props.strokeWidth * 2 + 'px',
                    top: props.strokeWidth + 'px',
                    left: props.strokeWidth + 'px'
                }}
            >
                {props.children}
            </div>
            <svg width={props.size} height={props.size}>
                {props.backgroundStrokeColor && (
                    <circle {...circleProps} stroke={props.backgroundStrokeColor} />
                )}
                <circle
                    {...circleProps}
                    stroke={props.strokeColor}
                    style={{ strokeDashoffset: (1 - props.progress) * circumference }}
                />
            </svg>
        </Wrapper>
    )
}

ProgressWheel.defaultProps = {
    size: 100,
    strokeWidth: 10,
    progress: 0.5
}

export const propTypes = (ProgressWheel.propTypes = {
    size: PropTypes.number,
    strokeWidth: PropTypes.number,
    strokeColor: PropTypes.string,
    backgroundStrokeColor: PropTypes.string,
    progress: PropTypes.number
})

export default memo(ProgressWheel)
